module.exports = __webpack_public_path__ + "img/Alternatives-Impact characterisation.1be71de5.svg";